import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/LogoutConfirmation.css'; // Import the CSS file

const LogoutConfirmation = ({ open, onClose, onConfirm }) => {
  const t = useTranslations('common.user_settings.logout_confirmation');

  return (
    <GenericPopup
      open={open}
      className="popup-confirm-logout-container_popup"
      opacity
    >
      <div className="popup-confirm-logout-container relative">
        <div className="popup-confirm-logout_header">
          <Text className="popup-confirm-logout_header-text">
            {t('title')}
          </Text>
          <XIcon className="popup-confirm-logout_close" onClick={onClose} />
        </div>

        <Text className="popup-confirm-logout_text">
          {t('description')}
        </Text>
      </div>
      <div className="popup-confirm-logout_buttons">
        <ContinueButton
          onClick={() => {
            onConfirm(); // Call the confirm function
            onClose(); // Close the dialog
          }}
          className="continue-button_two font-size-medium">
          {t('confirm_button')}
        </ContinueButton>
        <ContinueButton onClick={onClose} className="continue-button_two font-size-medium">
          {t('cancel_button')}
        </ContinueButton>
      </div>
    </GenericPopup>
  );
};

export default LogoutConfirmation;
